import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { TextProposalService } from '../laboratory/text-autocomplete/text-proposal.service';
import { MatDialog } from '@angular/material/dialog';
import { MessageService } from '../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { AddTextkuerzelDialog } from '../laboratory/text-autocomplete/text-autocomplete.component';
import { TextProposal } from '../laboratory/text-autocomplete/textkuerzel';

@Directive({ selector: '[kieneTextProposal]' })
export class TextProposalDirective {
    @Output('textChanged') textChanged = new EventEmitter<string>();

    constructor(
        private readonly el: ElementRef,
        private readonly service: TextProposalService,
        public dialog: MatDialog,
        public messageService: MessageService,
    ) {
        //
    }

    replaceText(proposal: TextProposal, found: string, splittedParams: string[]) {
        let newText = proposal.wortgruppe;

        // Ersetze die Platzhalter im Text
        if (splittedParams?.length > 0) {
            for (let i = 0; i < splittedParams.length; i++) {
                newText = newText.replace('$', splittedParams[i]);
            }
        }

        const neu = this.el.nativeElement.value.replace(found, newText);
        this.textChanged.emit(neu);
    }

    replaceTextHash(proposal: TextProposal, found: string, splittedParams: string[]) {
        let newText = proposal.wortgruppe;

        // Ersetze die Platzhalter im Text
        if (splittedParams?.length > 0) {
            for (let i = 0; i < splittedParams.length; i++) {
                newText = newText.replace('$', splittedParams[i]);
            }
        }

        const neu = this.el.nativeElement.value.replace(found + '#', newText);
        this.textChanged.emit(neu);
    }

    @HostListener('keyup', ['$event']) checkForProposal(event) {
        if (event.ctrlKey && event.code === 'Space') {
            const lastWord = this.el.nativeElement.value.split(' ').pop();
            console.log('lastWord', lastWord);
            const splittedParams = lastWord.split('-');
            const shortcut = splittedParams.shift();

            this.service.loadTextProposalForKey(shortcut).subscribe({
                next: (response: TextProposal) => {
                    if (response) {
                        this.replaceText(response, lastWord, splittedParams);
                    } else {
                        const proposal = new TextProposal();
                        proposal.textkuerzel = shortcut;
                        this.dialog
                            .open(AddTextkuerzelDialog, { width: '350px', data: proposal })
                            .afterClosed()
                            .subscribe((result: TextProposal) => {
                                if (result) {
                                    this.replaceText(result, lastWord, splittedParams);
                                }
                            });
                    }
                },
                error: () => {
                    const proposal = new TextProposal();
                    proposal.textkuerzel = shortcut;
                    this.dialog
                        .open(AddTextkuerzelDialog, { width: '350px', data: proposal })
                        .afterClosed()
                        .subscribe((result: TextProposal) => {
                            if (result) {
                                this.replaceText(result, lastWord, splittedParams);
                            }
                        });
                },
            });
        }
        if (event.key === '#') {
            const pattern = new RegExp('([A-Za-z0-9\\-]+#)');
            const match = pattern.exec(this.el.nativeElement.value);

            if (match) {
                // Extrahiere das Shortcut-Wort
                const found = match[1].replace('#', '');
                const splittedParams = found.split('-');
                const shortcut = splittedParams.shift();

                this.service.loadTextProposalForKey(shortcut).subscribe(
                    (response: TextProposal) => {
                        if (response) {
                            this.replaceTextHash(response, found, splittedParams);
                        }
                    },
                    () => {
                        const proposal = new TextProposal();
                        proposal.textkuerzel = shortcut;
                        this.dialog
                            .open(AddTextkuerzelDialog, { width: '350px', data: proposal })
                            .afterClosed()
                            .subscribe((result: TextProposal) => {
                                if (result) {
                                    this.replaceTextHash(result, found, splittedParams);
                                }
                            });
                    },
                );
            }
        }
    }
}
